'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002eutils$0024$002dChange$002dSet from "./presto.utils$-Change-Set.js";
var $p;
/** @constructor */
function $c_Lpresto_ItemSelector(items, selected, changes, filtered, filters) {
  this.Xy = null;
  this.wT = null;
  this.wQ = null;
  this.wR = null;
  this.wS = null;
  this.q6 = null;
  this.a8o = null;
  this.Xx = null;
  this.Xy = items;
  this.wT = selected;
  this.wQ = changes;
  this.wR = filtered;
  this.wS = filters;
  this.q6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.a4.a5(items.a3(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$15) => _$15.csX()))));
  this.a8o = selected.aW().q();
  this.Xx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_airstream_core_BaseObservable__distinct__Lcom_raquo_airstream_core_Observable($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_Lcom_raquo_airstream_misc_MapSignal__Lcom_raquo_airstream_core_Signal__F1__s_Option__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_airstream_misc_MapSignal(), selected, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((seq) => new $j_presto$002eutils$0024$002dChange$002dSet.$c_Lpresto_utils$ChangeSet(seq.b0(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((item) => (!this.a8o.aE(item))))), this.a8o.b0(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((seq$2) => ((item$2) => (!seq$2.aE(item$2))))(seq))), seq))), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$()));
}
export { $c_Lpresto_ItemSelector as $c_Lpresto_ItemSelector };
$p = $c_Lpresto_ItemSelector.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ItemSelector;
/** @constructor */
function $h_Lpresto_ItemSelector() {
}
export { $h_Lpresto_ItemSelector as $h_Lpresto_ItemSelector };
$h_Lpresto_ItemSelector.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_ItemSelector)) {
    var x = this.Xy;
    var x$2 = x$0.Xy;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      var x$3 = this.wT;
      var x$4 = x$0.wT;
      var $x_3 = (x$3 === x$4);
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$5 = this.wQ;
      var x$6 = x$0.wQ;
      var $x_2 = (x$5 === x$6);
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$7 = this.wR;
      var x$8 = x$0.wR;
      var $x_1 = (x$7 === x$8);
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$9 = this.wS;
      var x$10 = x$0.wS;
      return ((x$9 === null) ? (x$10 === null) : x$9.i(x$10));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 5;
});
$p.s = (function() {
  return "ItemSelector";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.Xy;
      break;
    }
    case 1: {
      return this.wT;
      break;
    }
    case 2: {
      return this.wQ;
      break;
    }
    case 3: {
      return this.wR;
      break;
    }
    case 4: {
      return this.wS;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_ItemSelector(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iy)));
}
export { $isArrayOf_Lpresto_ItemSelector as $isArrayOf_Lpresto_ItemSelector };
var $d_Lpresto_ItemSelector = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ItemSelector, "presto.ItemSelector", ({
  iy: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_ItemSelector as $d_Lpresto_ItemSelector };
//# sourceMappingURL=presto.-Item-Selector.js.map
